import { render, staticRenderFns } from "./AboutPage3.vue?vue&type=template&id=eb3eb30a&scoped=true"
import script from "./AboutPage3.vue?vue&type=script&lang=js"
export * from "./AboutPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3eb30a",
  null
  
)

export default component.exports